import {
  ASTRO_MAP_REPORT_SUBSCRIPTION_PLAN_ID,
  AURA_SCAN_REPORT_SUBSCRIPTION_PLAN_ID,
  SOULMATE_REPORT_SUBSCRIPTION_PLAN_ID,
  STAR_REPORT_SUBSCRIPTION_PLAN_ID,
  TRUTHS_REPORT_SUBSCRIPTION_PLAN_ID,
} from "@/features/subscriptions/report-plan-codes"

import type { ReportPurchaseType } from "./reports-data"

/**
 * Static plan code for the buyable reports (star/truths/soulmate/astromap/aura).
 * The backend report list (`byType(id).planId`) is the source of truth; these
 * are the client-side fallbacks used until that list has loaded.
 */
export function getReportPlanCode(purchaseType: ReportPurchaseType): string {
  if (purchaseType === "star") {
    return STAR_REPORT_SUBSCRIPTION_PLAN_ID
  }
  if (purchaseType === "truths") {
    return TRUTHS_REPORT_SUBSCRIPTION_PLAN_ID
  }
  if (purchaseType === "soulmate") {
    return SOULMATE_REPORT_SUBSCRIPTION_PLAN_ID
  }
  if (purchaseType === "astromap") {
    return ASTRO_MAP_REPORT_SUBSCRIPTION_PLAN_ID
  }
  if (purchaseType === "aura") {
    return AURA_SCAN_REPORT_SUBSCRIPTION_PLAN_ID
  }
  return ""
}

export function isPurchasableReport(
  purchaseType: ReportPurchaseType,
): purchaseType is "star" | "truths" | "soulmate" | "astromap" | "aura" {
  return (
    purchaseType === "star" ||
    purchaseType === "truths" ||
    purchaseType === "soulmate" ||
    purchaseType === "astromap" ||
    purchaseType === "aura"
  )
}
